/**
 * 404 Not Found page for unmatched routes.
 *
 * Renders a simple error message with a link back to the NOW page.
 * Used as the catch-all route in the router configuration.
 *
 * Phase 4 amendment 2026-04-27: the back-link color routes through the
 * theme accent token (Tactical Gold) so the page tracks the active SOC
 * palette in both light and dark mode. Previously hardcoded to a cyan
 * HSL string that bypassed the data-theme attribute selector.
 */
import { Link } from 'react-router-dom';
import { theme } from '@/design/tokens.css';

/**
 * NotFoundPage component.
 * Renders a 404 error with navigation back to the home screen.
 */
export function NotFoundPage() {
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
      }}
    >
      <h1>404 - Page Not Found</h1>
      <p style={{ opacity: 0.6 }}>The page you are looking for does not exist.</p>
      {/* Phase 20 MOB-09: 404 inline text-link (24px); recovery target is
          deep in the empty-state surface, not a primary tap target. Annotated
          for the mobile-smoke audit per Plan 20-08. */}
      <Link
        to="/now"
        style={{
          color: theme.colors.accent.gold,
          textDecoration: 'underline',
        }}
        data-tap-target-ignore
      >
        Back to NOW
      </Link>
    </main>
  );
}
